// ── Existing getters (null-safe) ──
export const getTg = () => window.Telegram
export const getTgLogin = () => window.Telegram?.Login
export const getTgWebApp = () => getTg()?.WebApp
export const getTgUser = () => getTgWebApp()?.initDataUnsafe?.user
export const getTgUserId = () => getTgUser()?.id

// ── Environment flag ──
export const isTelegramEnv = (): boolean => {
  try {
    const tg = window.Telegram?.WebApp
    return Boolean(tg && tg.platform !== "unknown")
  } catch {
    return false
  }
}

// ── Safe getters (return undefined instead of crash) ──
export const getTgLanguageCode = (): string | undefined =>
  getTgUser()?.language_code

export const getTgUserName = (): string =>
  [getTgUser()?.first_name, getTgUser()?.last_name].filter(Boolean).join(" ") ||
  ""

// ── Safe actions (no-op outside Telegram) ──
export const safeOpenTelegramLink = (url: string): void => {
  if (isTelegramEnv()) {
    try {
      getTgWebApp()?.openTelegramLink(url)
    } catch {
      window.open(url, "_blank")
    }
  } else {
    window.open(url, "_blank")
  }
}

export const safeOpenInvoice = (
  url: string,
  cb?: (status: string) => void
): boolean => {
  if (!isTelegramEnv()) return false
  getTgWebApp()?.openInvoice(url, cb)
  return true
}

export const safeInitTelegram = (): void => {
  if (!isTelegramEnv()) return
  const tg = getTgWebApp()
  if (!tg) return
  tg.ready()
  tg.expand()
  tg.disableClosingConfirmation()
  tg.disableVerticalSwipes?.()
  if (["android", "ios"].includes(tg.platform)) {
    tg.requestFullscreen?.()
  }
}

export const safeClose = (): void => {
  if (isTelegramEnv()) getTgWebApp()?.close?.()
}
